
import { Vue, Component, Prop } from "vue-property-decorator";
import EditButton from "./EditButton.vue";

@Component({
  components: {
    EditButton
  }
})
export default class SectionHeader extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: object;
}
